// File: NidhiCompanyCompliance.jsx
import React from "react";

export default function NidhiCompanyCompliance() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Nidhi Company Compliance
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks manages Nidhi Company statutory and RBI-linked compliances.
          </p>
          <p className="text-gray-700">
            Complete Nidhi Company compliance services including Form NDH-1/2/3, statutory returns, member registers, Form-A/B half-yearly returns, auditor coordination, and RBI deposit compliance under Nidhi Rules 2014.
          </p>
        </div>

        {/* Right: Image (NIDHI COMPANY COMPLIANCE SPECIFIC) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/394372/pexels-photo-394372.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Nidhi Company compliance services by Hawkins & Brooks"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless Nidhi compliance filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Member records and registers</li>
                <li>Financial statements</li>
                <li>Statutory returns (NDH-1, NDH-2, NDH-3)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Specialized Nidhi compliance expertise ensuring complete statutory and RBI compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Nidhi Rules Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of Nidhi Rules 2014 & Companies Act requirements including NDH-1 (member list), NDH-2 (half-yearly return), NDH-3 (auditor certificate), Form-A/B returns, 200 member requirement, Net Owned Fund compliance, and statutory ratio maintenance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  RBI & ROC Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise MCA & RBI compliance including Form NDH filings, auditor NDH-3 certificates, member KYC verification, statutory register maintenance, unencumbered term deposits, ratio validations (Membership, Deposits), and penalty avoidance through timely submissions.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Specialized Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service Nidhi compliance from member register maintenance through Form NDH filings, auditor coordination, ratio calculations, ROC inspections, statutory advisory, branch expansion compliance, and ongoing Nidhi-specific regulatory support.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
